// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"26e53af4","839":"d606d2a3"}[chunkId] + ".chunk.js";
};